import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Elana Gabrielle — Returning-customers (reorder) campaign (adc_xdbdjc5yr7).
// Real spend, conversions, and reorder ad sales from
// ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS. Monthly series lives
// in realBrandData.ts, covering the 19 complete months Feb 2025 – Aug 2026.
//
// `monthlyBudgetDollars` is the shared $400 pool; see camp_eg_new.
// CAMPAIGN_PERIODS attributes no first-year value to the reorder segment, so its
// sales come from TOTAL_SALES and the return is measured directly against spend.
export const campEgReorder: FaireAdCampaignEntity = {
  token: "camp_eg_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_elana_gabrielle",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 400,
  startedRunningAt: "2025-02-12",
  segmentMetrics: {
    numReorderConversions: 26,
    salesDollars: 7607,
    totalAdsSpendDollars: 858,
    returnOnAdSpend: 8.86,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
